import { IconButton, Stack } from '@mui/material';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import { Tooltip } from 'src/components/Tooltip/Tooltip';
import { AttributeText } from 'src/graphql/entities/custom-attributes/field-view-registry/components/attribute-text';
import { EmptyValue } from 'src/graphql/entities/custom-attributes/field-view-registry/components/empty-value';
import { CustomAttributeReadProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';

export const UrlView = ({ value }: CustomAttributeReadProps) => {
  const urlValue = getKindLikeValueSafely(value, 'url');

  if (!urlValue) {
    return <EmptyValue />;
  }
  const href = getSafeHref(urlValue);

  return (
    <Stack direction="row" alignItems="center" gap={0.5} sx={{ minWidth: 0 }}>
      <AttributeText
        sx={{
          wordBreak: 'break-all',
          color: href ? 'primary.main' : 'text.primary',
          textDecoration: href ? 'underline' : 'none',
          minWidth: 0,
        }}
      >
        {urlValue}
      </AttributeText>
      {href ? (
        <Tooltip title="Open in new tab">
          <IconButton
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            onClick={(event) => event.stopPropagation()}
            aria-label="Open URL in new tab"
            sx={{ padding: 0, width: '1.25rem', height: '1.25rem', flexShrink: 0 }}
          >
            <DynamicIcon name="open_in_new" sx={{ fontSize: '0.875rem' }} />
          </IconButton>
        </Tooltip>
      ) : null}
    </Stack>
  );
};

const SAFE_SCHEME = /^(https?|mailto|tel):/i;

const SCHEME_PRESENT = /^[a-z][a-z0-9+.-]*:/i;

function getSafeHref(rawValue: string): string | null {
  if (SAFE_SCHEME.test(rawValue)) {
    return rawValue;
  }
  if (SCHEME_PRESENT.test(rawValue)) {
    return null;
  }
  return `https://${rawValue}`;
}
